export default __webpack_public_path__ + "static/media/ppu-card-logo.ee103dda.svg";